import { Col, Row } from "react-bootstrap";

import { ServicoParagraph } from "../../components/Servico/ServicoStyled";
import img1 from "./images/httpsstoryset.comillustrationconstruction-workeramico.svg";
import img2 from "./images/httpsundraw.cosearchclients.svg";
import img3 from "./images/httpsundraw.cosearchopportunities.svg";
import img4 from "./images/httpsundraw.cosearchquality.svg";
import img5 from "./images/httpsundraw.cosearchsmart.svg";

export interface AboutUsInterface {
  title: string;
  description: () => React.ReactElement;
}

export const AboutUsEN: AboutUsInterface = {
  title: "About us",
  description: () => (
    <>
      <Row>
        <Col xs={12} md={3} className="d-md-none">
          <img
            className="img-fluid d-md-none"
            src={img1}
            alt=""
            style={{ maxWidth: "250px" }}
          />
        </Col>
        <Col xs={12} md={9}>
          <ServicoParagraph className={"my-2"}>
            Welcome to servi.co – a dedicated platform created to seamlessly
            connect individuals and businesses with capable service providers
            from a wide range of fields. Our core goal is to make the search for
            the right services as simple as possible – offering a combination of
            quality, reliability, and fair pricing. We believe that finding the
            right support should never be complicated. That’s why we strive to
            make the process as effortless as possible.
          </ServicoParagraph>
        </Col>
        <Col xs={12} md={3} className="d-none d-md-block">
          <img
            className="img-fluid"
            src={img1}
            alt=""
            style={{ maxWidth: "250px" }}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={3}>
          <img
            className="img-fluid"
            src={img3}
            alt=""
            style={{ maxWidth: "250px" }}
          />
        </Col>
        <Col xs={12} md={9}>
          <ServicoParagraph className={"my-2"}>
            We put great effort into ensuring that for every type of task, a
            suitable service provider can be found on our platform – through a
            simple, transparent search tailored to individual needs. Our mission
            is clear: we bring structure and clarity to a service industry that
            is often chaotic and fragmented. Our aim is to provide a secure,
            user-friendly environment where users can easily discover and
            contact service providers – free from the usual frustrations and
            uncertainties.
          </ServicoParagraph>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={3} className="d-md-none">
          <img
            className="img-fluid d-md-none"
            src={img4}
            alt=""
            style={{ maxWidth: "250px" }}
          />
        </Col>
        <Col xs={12} md={9}>
          <ServicoParagraph className={"my-2"}>
            Knowing how challenging it can be to find the right contact for a
            job, we aim to turn that process into a smooth and positive
            experience. Guided by the values of transparency, quality, speed,
            and fair pricing, servi.co is constantly working to improve the
            experience for all users. From the moment a job is posted, through
            intuitive navigation, to clear communication with potential service
            providers – we streamline every step to make finding and hiring the
            right support fast and efficient.
          </ServicoParagraph>
        </Col>
        <Col xs={12} md={3} className="d-none d-md-block">
          <img
            className="img-fluid"
            src={img4}
            alt=""
            style={{ maxWidth: "250px" }}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={3}>
          <img
            className="img-fluid"
            src={img5}
            alt=""
            style={{ maxWidth: "250px" }}
          />
        </Col>
        <Col xs={12} md={9}>
          <ServicoParagraph className={"my-2"}>
            Users can rely on a diverse pool of service providers with relevant
            experience – at competitive rates, with no hidden fees, and a strong
            focus on fairness and transparency. But servi.co is more than just a
            matchmaking platform – we actively support the growth of small and
            medium-sized businesses. Through a trusted digital marketplace, we
            enable service providers to showcase their skills, build their
            reputation, and reach new customers.
          </ServicoParagraph>
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={9}>
          <ServicoParagraph className={"my-2"}>
            We want to create a space where businesses can thrive – and clients
            receive the best possible service at the best possible price. Join
            us today and discover the new, smarter way to connect with service
            providers or explore new job opportunities. At servi.co, we’re here
            to help you not only find the right service – but to make every
            interaction a step toward success.
          </ServicoParagraph>
        </Col>
        <Col xs={12} md={3}>
          <img
            className="img-fluid"
            src={img2}
            alt=""
            style={{ maxWidth: "250px" }}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <ServicoParagraph className={"my-2"}>
            Join us today and experience the new, smarter way to connect with
            professionals. At servi.co, we’re here to help you not only find the
            service you need but to make every interaction a step towards
            greater success.
          </ServicoParagraph>
        </Col>
      </Row>
    </>
  ),
};

export const AboutUsDE: AboutUsInterface = {
  title: "Über uns",
  description: () => (
    <>
      <Row>
        <Col xs={12} md={3} className="d-md-none">
          <img
            className="img-fluid d-md-none"
            src={img1}
            alt=""
            style={{ maxWidth: "250px" }}
          />
        </Col>
        <Col xs={12} md={9}>
          <ServicoParagraph className={"my-2"}>
            Willkommen bei servi.co – einer engagierten Plattform, die dafür
            geschaffen wurde, Privatpersonen und Unternehmen nahtlos mit
            kompetenten Dienstleister:innen aus verschiedensten Bereichen zu
            verbinden. Unser zentrales Ziel: die Suche nach passenden Services
            so einfach wie möglich zu gestalten – mit einer Kombination aus
            Qualität, Verlässlichkeit und fairen Preisen.
          </ServicoParagraph>
        </Col>
        <Col xs={12} md={3} className="d-none d-md-block">
          <img
            className="img-fluid"
            src={img1}
            alt=""
            style={{ maxWidth: "250px" }}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={3}>
          <img
            className="img-fluid"
            src={img3}
            alt=""
            style={{ maxWidth: "250px" }}
          />
        </Col>
        <Col xs={12} md={9}>
          <ServicoParagraph className={"my-2"}>
            Denn wir sind überzeugt: Die richtige Unterstützung zu finden,
            sollte nie kompliziert sein. Und genau deshalb machen wir diesen
            Prozess so mühelos wie möglich. Wir setzen alles daran, dass für
            jede Art von Aufgabe ein:e passende:r Dienstleister:in über unsere
            Plattform gefunden werden kann – durch eine einfache, transparente
            und auf individuelle Bedürfnisse zugeschnittene Suche. Unsere
            Mission ist klar: Wir bringen Struktur und Übersicht in eine oft
            chaotische und fragmentierte Servicebranche.
          </ServicoParagraph>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={3} className="d-md-none">
          <img
            className="img-fluid d-md-none"
            src={img4}
            alt=""
            style={{ maxWidth: "250px" }}
          />
        </Col>
        <Col xs={12} md={9}>
          <ServicoParagraph className={"my-2"}>
            Unser Anspruch ist es, eine sichere und benutzerfreundliche Umgebung
            zu schaffen, in der Nutzer:innen Dienstleister:innen ganz
            unkompliziert entdecken und kontaktieren können – frei von den
            üblichen Frustrationen und Unsicherheiten. In dem Bewusstsein, dass
            es oft herausfordernd ist, passende Ansprechpersonen für einen
            Auftrag zu finden, möchten wir diesen Prozess in eine positive und
            reibungslose Erfahrung verwandeln.
          </ServicoParagraph>
        </Col>
        <Col xs={12} md={3} className="d-none d-md-block">
          <img
            className="img-fluid"
            src={img4}
            alt=""
            style={{ maxWidth: "250px" }}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={3}>
          <img
            className="img-fluid"
            src={img5}
            alt=""
            style={{ maxWidth: "250px" }}
          />
        </Col>
        <Col xs={12} md={9}>
          <ServicoParagraph className={"my-2"}>
            Geleitet von den Werten Transparenz, Qualität, Schnelligkeit und
            fairer Preisgestaltung arbeitet servi.co kontinuierlich daran, das
            Erlebnis für alle Nutzer:innen zu verbessern. Vom Moment der
            Auftragserstellung über eine intuitive Navigation bis hin zur klaren
            Kommunikation mit potenziellen Dienstleister:innen – wir optimieren
            jeden Schritt, damit das Finden und Beauftragen der passenden
            Unterstützung schnell und effizient gelingt. Nutzer:innen können
            sich darauf verlassen, aus einem vielfältigen Pool an
            Dienstleister:innen mit relevanter Erfahrung zu wählen – zu
            wettbewerbsfähigen Preisen, ohne versteckte Kosten und mit einem
            klaren Fokus auf Fairness und Transparenz.
          </ServicoParagraph>
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={9}>
          <ServicoParagraph className={"my-2"}>
            Doch servi.co ist mehr als nur eine Vermittlungsplattform – wir
            fördern aktiv das Wachstum von kleinen und mittelständischen
            Unternehmen. Durch einen vertrauenswürdigen digitalen Marktplatz
            bieten wir Dienstleister:innen die Möglichkeit, ihre Fähigkeiten zu
            präsentieren, ihre Reputation zu stärken und neue Kund:innen zu
            gewinnen. Wir möchten einen Raum schaffen, in dem Unternehmen
            florieren – und Kund:innen den bestmöglichen Service zum besten
            Preis erhalten.
          </ServicoParagraph>
        </Col>
        <Col xs={12} md={3}>
          <img
            className="img-fluid"
            src={img2}
            alt=""
            style={{ maxWidth: "250px" }}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <ServicoParagraph className={"my-2"}>
            Mach noch heute mit und entdecke den neuen, smarten Weg, um mit
            Dienstleister:innen oder neuen Jobangeboten in Kontakt zu treten.
            Bei servi.co helfen wir dir nicht nur, den passenden Service zu
            finden – sondern machen jede Interaktion zu einem Schritt in
            Richtung Erfolg.
          </ServicoParagraph>
        </Col>
      </Row>
    </>
  ),
};
